import { render } from "./event_media_gallery.html?vue&type=template&id=ebd7646a&external"
import script from "./event_media_gallery.js?vue&type=script&lang=js&external"
export * from "./event_media_gallery.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__